export default __webpack_public_path__ + "static/media/logo-flourish.e45d75c0.svg";